export class ApiObjAdminUserPrice {
    
    price_object_id: number;
    price: number
    
    constructor(data: any) {
        this.price_object_id = parseInt(data.price_object_id);
        this.price = parseFloat(data.price);
    }
}